module.exports = __webpack_public_path__ + "img/ME.7d965b31.png";